import React from "react";
import {cmpClassName} from "../../../common/generic-react.functions.js";
import {SectionTitleContainer} from "./section-title.styles.js";
function SectionTitle({
  children,
  tag = "h2",
  bold = "semi",
  size = "md"
}) {
  return /* @__PURE__ */ React.createElement(SectionTitleContainer, {
    className: cmpClassName("section-title") + " SectionTitleContainer",
    tag,
    bold,
    size
  }, children);
}
export default /* @__PURE__ */ React.memo(SectionTitle);
